import { handleRequest } from "../utilities/requestHandler";

export const saveRequestList = (req_body) =>
    handleRequest("post","/request_list/saverequestlist", req_body);

export const saveProductForLater = (req_body) =>
    handleRequest("post","/saved_for_later/saveproduct", req_body);